// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"70630fac","249":"61365568","467":"0fe2b537","483":"17f52303","694":"53fa1751","872":"29991020","914":"4426b24c","938":"5bb67f3d"}[chunkId] + ".chunk.css";
};